import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { BROADCAST_LOGGED_OUT_CHANNEL } from '@/modules/shared/broadcast-channels'
import { useAlert } from '@/modules/shared/hooks/useAlert'
import { useBroadcastChannel } from '@/modules/shared/hooks/useBroadcastChannel'

export function LoggedOutBroadast() {
  const { subscribe } = useBroadcastChannel(BROADCAST_LOGGED_OUT_CHANNEL, true)
  const { alertDialog } = useAlert()
  const { t } = useTranslation()

  useEffect(() => {
    subscribe((loggedOut) => {
      if (!loggedOut) return
      //  Users still can navigate around the app when we logout in other tabs
      //  so we need to force all the tabs to reload to avoid this issue
      alertDialog({
        persistent: true,
        type: 'error',
        title: t('alert.loggedOut.title', 'You are signed out'),
        message: t('alert.loggedOut.message', 'You are signed out, please sign in again.'),
        buttonText: t('general.signIn', 'Sign In'),
        onButtonClick() {
          window.location.reload()
        },
      })
    })
  }, [subscribe])

  return null
}
